import { render, staticRenderFns } from "./SeperationTradeData.vue?vue&type=template&id=1837635e&"
import script from "./SeperationTradeData.vue?vue&type=script&lang=js&"
export * from "./SeperationTradeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports